define('modules/home/main/views/history.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    'modules/base/models/home.activities.model',
    'modules/base/views/lazy.paging.view',
    'modules/home/main/views/get.more.history.view',
    'modules/home/main/views/history.item.view',
    'modules/home/main/views/history.date.view',
    'text!modules/home/main/templates/empty.history.template.html'
], function(Prospector,$, _,Backbone,
            Marionette,
            HomeActivitiesModel,
            LazyPagingView,
            GetMoreView,
            HistoryItemView,
            HistoryDateView,
            EmptyResultsTemplate
) {
    var HistoryView = LazyPagingView.extend({
        template: _.template(''),
        emptyTemplate: _.template(EmptyResultsTemplate),
        className: 'historyHolder',
        modelSelector: '',
        loader: 'ripple',
        loaderHtml: '<div></div><div></div>',
        date: '',
        mEvents:function() {
            var base = {
            };
            var click = {
                'click .settings': 'settings',
                'click .viewComments': 'openAddComment',
                'click .addCardBtn': 'openAddCard',
                'click .searchForProfiles' : 'procSearchForProfiles'
            };
            $.extend(base,click);
            return base;
        },
        procSearchForProfiles:function(){
            Prospector.trigger('closeHistoryDrawer');
            Prospector.navigate('dashboard', true);
        },
        getGetMoreView:function(){
            return new GetMoreView({parent: this});
        },
        initialize: function(options){
            LazyPagingView.prototype.initialize.call(this, options);
            this.firstLoad = true;
            Prospector.on("buildHistory", this.refresh, this);
        },
        buildModel:function(){
            this.model = new HomeActivitiesModel({
                type: 'items'
            });
            this.model.pageSize = 50;
        },
        onRender:function(){
            this.modelSelector = this.el;
            LazyPagingView.prototype.onRender.call(this);
        },
        refresh:function(){
            this.firstLoad = true;
            this.date = "";
            this.fetchModel();
        },
        procResponse:function(){
            this.prependGetMore();
        },
        getAdditionalViews:function(){
            var views = new Array();
            if(this.model.get('items') != undefined && this.model.get('items').length > 0){
                var identityDate = "";
                _.each(this.model.get('items'), function(identity){
                        identityDate = identity.timeLastViewed.split(" ")[0];
                        if (identityDate != this.date) {
                            this.date = identityDate;
                            var dv = new HistoryDateView({identityDate: identity.timeLastViewed});
                            views.push(dv);
                        }
                        var iv = new HistoryItemView({identity: identity});
                        views.push(iv);
                }, this);
            } else {
                if(this.firstLoad){
                    $(this.el).append(this.emptyTemplate);
                }
            }
            this.isFirstLoad = false;
            return views;
        }
    });
    return HistoryView;
});
